// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   MCR Brands — premium listing
   ========================================================================== */

.mcrb-page {
  padding: 28px;
  background: #f4f5f7;
  min-height: calc(100vh - 60px);
}

.mcrb-card {
  max-width: 1100px;
  margin: 0 auto;
  background: #ffffff;
  border: 1px solid #e6e8ec;
  border-radius: 18px;
  box-shadow: 0 10px 40px -18px rgba(15, 23, 42, 0.18);
  overflow: hidden;
}

/* ---------- Card header ------------------------------------------------ */
.mcrb-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 24px 28px;
  background: linear-gradient(165deg, #24123f 0%, #4c2fb3 55%, #7c5cfc 100%);
  color: #f8fafc;
}

.mcrb-head-title {
  margin: 0;
  font-size: 19px;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.mcrb-head-sub {
  margin: 6px 0 0;
  font-size: 12.5px;
  color: #c9bef0;
  letter-spacing: 0.02em;
}

.mcrb-head-stats {
  display: flex;
  gap: 14px;
}

.mcrb-stat {
  min-width: 96px;
  padding: 10px 16px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
  text-align: right;
}

.mcrb-stat-num {
  display: block;
  font-size: 18px;
  font-weight: 700;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  color: #ffffff;
}

.mcrb-stat-label {
  display: block;
  margin-top: 2px;
  font-size: 10.5px;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: #b6a9e6;
}

/* ---------- Toolbar (search) --------------------------------------- */
.mcrb-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 24px;
  background: #fbfbfc;
  border-bottom: 1px solid #eceef1;
}

.mcrb-search {
  position: relative;
  display: flex;
  align-items: center;
  width: 320px;
  max-width: 100%;
}

.mcrb-search > svg {
  position: absolute;
  left: 13px;
  color: #94a3b8;
  pointer-events: none;
}

.mcrb-search input {
  width: 100%;
  height: 38px;
  padding: 0 34px 0 36px;
  border: 1px solid #dfe3e8;
  border-radius: 10px;
  background: #ffffff;
  font-size: 13px;
  color: #1f2937;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.mcrb-search input:focus {
  border-color: #7c5cfc;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.18);
}

.mcrb-search-clear {
  position: absolute;
  right: 8px;
  width: 20px;
  height: 20px;
  border: none;
  border-radius: 50%;
  background: #e2e8f0;
  color: #475569;
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  display: grid;
  place-items: center;
}

.mcrb-search-clear:hover {
  background: #cbd5e1;
}

.mcrb-result-count {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  white-space: nowrap;
}

/* ---------- Table region ------------------------------------------- */
.mcrb-scroll {
  overflow-x: auto;
}

/* ---------- Table -------------------------------------------------- */
.mcrb-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 13.5px;
}

.mcrb-table thead th {
  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);
  color: #ede9fb;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  text-align: left;
  padding: 15px 24px;
  border-bottom: 1px solid #5b3fc8;
  white-space: nowrap;
}

.mcrb-th-rank { width: 78px; text-align: center; }
.mcrb-th-count { width: 150px; text-align: center; }

.mcrb-table thead th:nth-child(2) {
  padding-left: 71px;
}

.mcrb-table tbody td {
  padding: 14px 24px;
  border-bottom: 1px solid #eef0f3;
  color: #1f2937;
  vertical-align: middle;
}

.mcrb-table tbody td:first-child {
  text-align: center;
}

.mcrb-table tbody tr:last-child td {
  border-bottom: none;
}

.mcrb-table tbody tr {
  transition: background 0.14s ease;
}

.mcrb-table tbody tr:hover {
  background: #f8fafc;
}

/* rank */
.mcrb-rank {
  display: inline-block;
  min-width: 30px;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  font-size: 12.5px;
  font-weight: 600;
  color: #94a3b8;
  text-align: center;
}

/* brand cell */
.mcrb-brand {
  display: flex;
  align-items: center;
  gap: 13px;
}

.mcrb-badge {
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  font-size: 13px;
  font-weight: 700;
  color: #ffffff;
  background: linear-gradient(135deg, #4c2fb3, #7c5cfc);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08);
  text-transform: uppercase;
}

.mcrb-brand-name {
  font-weight: 600;
  color: #0f172a;
  letter-spacing: 0.01em;
}

/* count */
.mcrb-count {
  text-align: center;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  font-size: 13.5px;
  color: #0f172a;
}

.mcrb-count-unit {
  margin-left: 4px;
  font-size: 10.5px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #9aa4b2;
}

/* ---------- Wide product table ----------------------------------- */
.mcrb-table--wide {
  min-width: 1180px;
}

.mcrb-th-num {
  text-align: right !important;
  white-space: nowrap;
}

.mcrb-num {
  text-align: right;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  white-space: nowrap;
  color: #0f172a;
}

.mcrb-num--amazon { color: #047857; }
.mcrb-num--flipkart { color: #1d4ed8; }

.mcrb-prod-name {
  display: block;
  max-width: 320px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mcrb-chip {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 999px;
  background: #ede9fb;
  color: #4c2fb3;
  font-size: 12px;
  font-weight: 700;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}

.mcrb-empty-row {
  padding: 48px 24px !important;
  text-align: center;
  color: #94a3b8;
  font-size: 13px;
}

/* ---------- Pagination -------------------------------------------- */
.mcrb-pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 14px 24px;
  background: #fbfbfc;
  border-top: 1px solid #eceef1;
  flex-wrap: wrap;
}

.mcrb-pager-info {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
}

.mcrb-pager-controls {
  display: flex;
  align-items: center;
  gap: 4px;
}

.mcrb-pager-btn,
.mcrb-pager-num {
  height: 32px;
  min-width: 32px;
  padding: 0 10px;
  border: 1px solid #dfe3e8;
  border-radius: 8px;
  background: #ffffff;
  color: #475569;
  font-size: 12.5px;
  font-weight: 600;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  cursor: pointer;
  transition: background 0.14s ease, border-color 0.14s ease, color 0.14s ease;
}

.mcrb-pager-btn:hover:not(:disabled),
.mcrb-pager-num:hover:not(.is-active) {
  background: #f1f5f9;
  border-color: #cbd5e1;
}

.mcrb-pager-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.mcrb-pager-num.is-active {
  background: linear-gradient(135deg, #4c2fb3, #7c5cfc);
  border-color: transparent;
  color: #ffffff;
}

.mcrb-pager-ellipsis {
  padding: 0 4px;
  color: #94a3b8;
  font-size: 12.5px;
  -webkit-user-select: none;
          user-select: none;
}

/* states */
.mcrb-state {
  padding: 64px 24px;
  text-align: center;
  color: #64748b;
  font-size: 14px;
}

.mcrb-state--error { color: #b91c1c; }

.mcrb-spinner {
  width: 26px;
  height: 26px;
  margin: 0 auto 14px;
  border: 3px solid #e2e8f0;
  border-top-color: #7c5cfc;
  border-radius: 50%;
  animation: mcrb-spin 0.7s linear infinite;
}

@keyframes mcrb-spin {
  to { transform: rotate(360deg); }
}

@media (max-width: 640px) {
  .mcrb-page { padding: 14px; }
  .mcrb-head { flex-direction: column; align-items: flex-start; }
  .mcrb-toolbar { flex-direction: column; align-items: stretch; }
  .mcrb-search { width: 100%; }
  .mcrb-pager { justify-content: center; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/MRC-Products/McrBrands.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,oDAAoD;EACpD,gBAAgB;AAClB;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,0EAA0E;EAC1E,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6BAAkC;EAAlC,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,wEAAwE;AACxE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,aAAa;EACb,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,wEAAwE;AACxE;EACE,gBAAgB;AAClB;;AAEA,wEAAwE;AACxE;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,gBAAgB,WAAW,EAAE,kBAAkB,EAAE;AACjD,iBAAiB,YAAY,EAAE,kBAAkB,EAAE;;AAEnD;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,qBAAqB;EACrB,eAAe;EACf,6BAAkC;EAAlC,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qDAAqD;EACrD,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,6BAAkC;EAAlC,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,sEAAsE;AACtE;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,6BAAkC;EAAlC,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oBAAoB,cAAc,EAAE;AACpC,sBAAsB,cAAc,EAAE;;AAEtC;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6BAAkC;EAAlC,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6BAAkC;EAAlC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,6BAAkC;EAAlC,kCAAkC;EAClC,eAAe;EACf,4EAA4E;AAC9E;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,qBAAqB,cAAc,EAAE;;AAErC;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,aAAa,aAAa,EAAE;EAC5B,aAAa,sBAAsB,EAAE,uBAAuB,EAAE;EAC9D,gBAAgB,sBAAsB,EAAE,oBAAoB,EAAE;EAC9D,eAAe,WAAW,EAAE;EAC5B,cAAc,uBAAuB,EAAE;AACzC","sourcesContent":["/* ==========================================================================\n   MCR Brands — premium listing\n   ========================================================================== */\n\n.mcrb-page {\n  padding: 28px;\n  background: #f4f5f7;\n  min-height: calc(100vh - 60px);\n}\n\n.mcrb-card {\n  max-width: 1100px;\n  margin: 0 auto;\n  background: #ffffff;\n  border: 1px solid #e6e8ec;\n  border-radius: 18px;\n  box-shadow: 0 10px 40px -18px rgba(15, 23, 42, 0.18);\n  overflow: hidden;\n}\n\n/* ---------- Card header ------------------------------------------------ */\n.mcrb-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  padding: 24px 28px;\n  background: linear-gradient(165deg, #24123f 0%, #4c2fb3 55%, #7c5cfc 100%);\n  color: #f8fafc;\n}\n\n.mcrb-head-title {\n  margin: 0;\n  font-size: 19px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n}\n\n.mcrb-head-sub {\n  margin: 6px 0 0;\n  font-size: 12.5px;\n  color: #c9bef0;\n  letter-spacing: 0.02em;\n}\n\n.mcrb-head-stats {\n  display: flex;\n  gap: 14px;\n}\n\n.mcrb-stat {\n  min-width: 96px;\n  padding: 10px 16px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  text-align: right;\n}\n\n.mcrb-stat-num {\n  display: block;\n  font-size: 18px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  color: #ffffff;\n}\n\n.mcrb-stat-label {\n  display: block;\n  margin-top: 2px;\n  font-size: 10.5px;\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  color: #b6a9e6;\n}\n\n/* ---------- Toolbar (search) --------------------------------------- */\n.mcrb-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 14px 24px;\n  background: #fbfbfc;\n  border-bottom: 1px solid #eceef1;\n}\n\n.mcrb-search {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 320px;\n  max-width: 100%;\n}\n\n.mcrb-search > svg {\n  position: absolute;\n  left: 13px;\n  color: #94a3b8;\n  pointer-events: none;\n}\n\n.mcrb-search input {\n  width: 100%;\n  height: 38px;\n  padding: 0 34px 0 36px;\n  border: 1px solid #dfe3e8;\n  border-radius: 10px;\n  background: #ffffff;\n  font-size: 13px;\n  color: #1f2937;\n  outline: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.mcrb-search input:focus {\n  border-color: #7c5cfc;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.18);\n}\n\n.mcrb-search-clear {\n  position: absolute;\n  right: 8px;\n  width: 20px;\n  height: 20px;\n  border: none;\n  border-radius: 50%;\n  background: #e2e8f0;\n  color: #475569;\n  font-size: 14px;\n  line-height: 1;\n  cursor: pointer;\n  display: grid;\n  place-items: center;\n}\n\n.mcrb-search-clear:hover {\n  background: #cbd5e1;\n}\n\n.mcrb-result-count {\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748b;\n  white-space: nowrap;\n}\n\n/* ---------- Table region ------------------------------------------- */\n.mcrb-scroll {\n  overflow-x: auto;\n}\n\n/* ---------- Table -------------------------------------------------- */\n.mcrb-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 13.5px;\n}\n\n.mcrb-table thead th {\n  background: linear-gradient(135deg, #4c2fb3 0%, #7c5cfc 100%);\n  color: #ede9fb;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  text-align: left;\n  padding: 15px 24px;\n  border-bottom: 1px solid #5b3fc8;\n  white-space: nowrap;\n}\n\n.mcrb-th-rank { width: 78px; text-align: center; }\n.mcrb-th-count { width: 150px; text-align: center; }\n\n.mcrb-table thead th:nth-child(2) {\n  padding-left: 71px;\n}\n\n.mcrb-table tbody td {\n  padding: 14px 24px;\n  border-bottom: 1px solid #eef0f3;\n  color: #1f2937;\n  vertical-align: middle;\n}\n\n.mcrb-table tbody td:first-child {\n  text-align: center;\n}\n\n.mcrb-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.mcrb-table tbody tr {\n  transition: background 0.14s ease;\n}\n\n.mcrb-table tbody tr:hover {\n  background: #f8fafc;\n}\n\n/* rank */\n.mcrb-rank {\n  display: inline-block;\n  min-width: 30px;\n  font-variant-numeric: tabular-nums;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #94a3b8;\n  text-align: center;\n}\n\n/* brand cell */\n.mcrb-brand {\n  display: flex;\n  align-items: center;\n  gap: 13px;\n}\n\n.mcrb-badge {\n  flex: 0 0 auto;\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  display: grid;\n  place-items: center;\n  font-size: 13px;\n  font-weight: 700;\n  color: #ffffff;\n  background: linear-gradient(135deg, #4c2fb3, #7c5cfc);\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08);\n  text-transform: uppercase;\n}\n\n.mcrb-brand-name {\n  font-weight: 600;\n  color: #0f172a;\n  letter-spacing: 0.01em;\n}\n\n/* count */\n.mcrb-count {\n  text-align: center;\n  font-variant-numeric: tabular-nums;\n  font-weight: 700;\n  font-size: 13.5px;\n  color: #0f172a;\n}\n\n.mcrb-count-unit {\n  margin-left: 4px;\n  font-size: 10.5px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #9aa4b2;\n}\n\n/* ---------- Wide product table ----------------------------------- */\n.mcrb-table--wide {\n  min-width: 1180px;\n}\n\n.mcrb-th-num {\n  text-align: right !important;\n  white-space: nowrap;\n}\n\n.mcrb-num {\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n  font-weight: 600;\n  white-space: nowrap;\n  color: #0f172a;\n}\n\n.mcrb-num--amazon { color: #047857; }\n.mcrb-num--flipkart { color: #1d4ed8; }\n\n.mcrb-prod-name {\n  display: block;\n  max-width: 320px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.mcrb-chip {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 999px;\n  background: #ede9fb;\n  color: #4c2fb3;\n  font-size: 12px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n\n.mcrb-empty-row {\n  padding: 48px 24px !important;\n  text-align: center;\n  color: #94a3b8;\n  font-size: 13px;\n}\n\n/* ---------- Pagination -------------------------------------------- */\n.mcrb-pager {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 14px 24px;\n  background: #fbfbfc;\n  border-top: 1px solid #eceef1;\n  flex-wrap: wrap;\n}\n\n.mcrb-pager-info {\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748b;\n  font-variant-numeric: tabular-nums;\n}\n\n.mcrb-pager-controls {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.mcrb-pager-btn,\n.mcrb-pager-num {\n  height: 32px;\n  min-width: 32px;\n  padding: 0 10px;\n  border: 1px solid #dfe3e8;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #475569;\n  font-size: 12.5px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  cursor: pointer;\n  transition: background 0.14s ease, border-color 0.14s ease, color 0.14s ease;\n}\n\n.mcrb-pager-btn:hover:not(:disabled),\n.mcrb-pager-num:hover:not(.is-active) {\n  background: #f1f5f9;\n  border-color: #cbd5e1;\n}\n\n.mcrb-pager-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.mcrb-pager-num.is-active {\n  background: linear-gradient(135deg, #4c2fb3, #7c5cfc);\n  border-color: transparent;\n  color: #ffffff;\n}\n\n.mcrb-pager-ellipsis {\n  padding: 0 4px;\n  color: #94a3b8;\n  font-size: 12.5px;\n  user-select: none;\n}\n\n/* states */\n.mcrb-state {\n  padding: 64px 24px;\n  text-align: center;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.mcrb-state--error { color: #b91c1c; }\n\n.mcrb-spinner {\n  width: 26px;\n  height: 26px;\n  margin: 0 auto 14px;\n  border: 3px solid #e2e8f0;\n  border-top-color: #7c5cfc;\n  border-radius: 50%;\n  animation: mcrb-spin 0.7s linear infinite;\n}\n\n@keyframes mcrb-spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (max-width: 640px) {\n  .mcrb-page { padding: 14px; }\n  .mcrb-head { flex-direction: column; align-items: flex-start; }\n  .mcrb-toolbar { flex-direction: column; align-items: stretch; }\n  .mcrb-search { width: 100%; }\n  .mcrb-pager { justify-content: center; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
